import { readPurchasePriceVisible, writePurchasePriceVisible } from '@/utils/purchasePriceVisible'

export default {
  state: () => ({
    config: {},
    purchasePriceVisible: readPurchasePriceVisible(),
  }),
  mutations: {
    setConfig(state, item) {
      for (let key of Object.keys(item)) {
        state.config[key] = item[key].strategy;
      }
    },
    setPurchasePriceVisible(state, value) {
      state.purchasePriceVisible = !!value
      writePurchasePriceVisible(!!value)
    },
  }
}